import * as React from 'react'
function SvgTeam(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M12.125 22.5c4.016 0 6.838 1.593 8.465 2.884 1.064.844 1.66 2.138 1.66 3.497v.62a1.993 1.993 0 01-1.997 1.999H3.997A2 2 0 012 29.502v-.621c0-1.359.596-2.653 1.66-3.497C5.287 24.093 8.11 22.5 12.125 22.5zm15.75 0c4.016 0 6.838 1.593 8.465 2.884 1.064.844 1.66 2.138 1.66 3.497v.62a1.993 1.993 0 01-1.998 1.999H26.75v-2.619c0-2.25-.844-4.336-2.293-5.956a13.963 13.963 0 013.418-.425zM12.125 9a5.625 5.625 0 110 11.25 5.625 5.625 0 010-11.25zm15.75 0a5.625 5.625 0 110 11.25 5.625 5.625 0 010-11.25z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgTeam
